import { render } from "./ButtonRight.vue?vue&type=template&id=4e21a7ae&scoped=true"
import script from "./ButtonRight.vue?vue&type=script&lang=js"
export * from "./ButtonRight.vue?vue&type=script&lang=js"

import "./ButtonRight.vue?vue&type=style&index=0&id=4e21a7ae&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e21a7ae"]])

export default __exports__